module.exports = __webpack_public_path__ + "img/welcome.6e50732c.png";